import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { promoGoodsFormAction } from "../../redux/rootReducer";
import { PROMO_GOODS_FORM_INITIAL } from "../../redux/initialStateConstant";
import Checkbox from "../Checkbox/Checkbox";
import { updatePromoGoodsSagaAction } from "../../redux/sagaActions";

const PromoGoodsForm = () => {
    const dispatch = useDispatch();
    const promo_goods_form = useSelector(state => state.promo_goods_form);

    let checkedAll = promo_goods_form.goods.filter(elem => elem.checked).length === promo_goods_form.goods.length;

    if (!promo_goods_form.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                           onClick={ () => dispatch(promoGoodsFormAction(PROMO_GOODS_FORM_INITIAL)) }
                        />
                        <div className="form__title">{ `Промокод ${ promo_goods_form.promo_code }` }</div>
                    </div>
                    <div className="form__field">
                        {
                            promo_goods_form.goods.map((elem, index) => {
                                return (
                                    <div key={ elem.id } style={{ marginBottom: 5 }}>
                                        <Checkbox
                                            active={ elem.checked }
                                            caption={ elem.name }
                                            handler={ () => {
                                                // Новый массив с товарами
                                                let newGoods = [...promo_goods_form.goods];
                                                newGoods[index] = { ...newGoods[index], checked: !newGoods[index].checked };

                                                dispatch(promoGoodsFormAction({
                                                    ...promo_goods_form,
                                                    goods: newGoods
                                                }));
                                            } }
                                        />
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="promo__check-all"
                            onClick={ () => {
                                // Новый массив с товарами
                                let newGoods = [...promo_goods_form.goods];

                                newGoods = newGoods.map(elem => ({ ...elem, checked: !checkedAll }));

                                dispatch(promoGoodsFormAction({
                                    ...promo_goods_form,
                                    goods: newGoods
                                }));
                            } }
                        >
                            { checkedAll ? 'Снять всё' : 'Отметить всё' }
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                let goods = promo_goods_form.goods.filter(elem => elem.checked).map(elem => elem.id);
                                dispatch(updatePromoGoodsSagaAction({
                                    promo_id: promo_goods_form.promo_id,
                                    goods: JSON.stringify(goods),
                                    goods_count: goods.length
                                }))
                            } }
                        >
                            Сохранить
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PromoGoodsForm;